import Aparecer from './Aparecer';
import type { EntradasAvulsas } from '@/pages/gerenciar/painel/financeiro/relatorio/types';
import { formatarCentavos } from '@/pages/loja/utils';

export default function SecaoEntradas({ e }: { e: EntradasAvulsas }) {
  return (
    <Aparecer>
      <section className="rel-secao rounded-2xl border border-background-200 bg-white p-4 shadow-[0_1px_3px_rgba(16,24,40,0.04)] md:p-5">
        <div className="flex flex-wrap items-baseline justify-between gap-x-3">
          <h2 className="text-[15px] font-bold text-foreground-950">Entradas avulsas</h2>
          <span className="text-[17px] font-extrabold tabular-nums text-foreground-950">
            {formatarCentavos(e.total_centavos)}
          </span>
        </div>
        <p className="mt-1 text-[12px] text-foreground-500">
          {e.quantidade} {e.quantidade === 1 ? 'entrada' : 'entradas'}
        </p>
      </section>
    </Aparecer>
  );
}